import './styles/reset.css';
import RoutesApp from './router';

function App() {
  return (
    <RoutesApp />
  );
}

export default App;
